import { IconCtaColoredBoxCardProps } from '@ahc-digital/component-library';
import { getDroplink } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C32IconCTAColoredBoxCardProps } from './C32IconCTAColoredBoxCard.types';
import { getKvpValue } from '@/shared/field-utils';

export function CreateIconCTAColoredBoxCardModel(props?: C32IconCTAColoredBoxCardProps) {
  type t = IconCtaColoredBoxCardProps;
  const { params, fields } = props || {};
  const { renderRichText, renderText, renderLink } = useConditionalRendering();

  return {
    icon: getKvpValue<t['icon']>(fields?.Icon),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    headline: renderText(fields?.Headline) as t['headline'],
    supportCopy: renderRichText(fields?.SupportCopy) as t['supportCopy'],
    cardCTA: renderLink(fields?.CardCTA) as t['cardCTA'],
  };
}
